import { Form } from '@domain-group/suit-theme'

import type { UseFormPayload } from '@domain-group/react-hooks'

import useStatuses from '@hooks/useStatuses'

import type { UseProviderDeepLinkPayload } from '@hooks/useProviderDeepLink'

interface ManageDeepLinkProps {
  formPayload: UseFormPayload,
  deepLinkStatusKeys?: UseProviderDeepLinkPayload['deepLinkStatusKeys'],
}

const ManageDeepLink = (props: ManageDeepLinkProps) => {
  const {
    deepLinkStatusKeys,
    formPayload,
  } = props

  const {
    entityState: {
      link_text,
      status_id,
      title,
      url,
    },
    handlers,
    setEntityState,
  } = formPayload

  // @ts-expect-error TS2322
  const statusesPayload = useStatuses({ filters: { status_keys: deepLinkStatusKeys } })
  const { filteredStatuses } = statusesPayload

  return (
    <>
      <Form.Field label="* Title">
        <input name="title" value={title} type="text" {...handlers} />
      </Form.Field>

      <Form.Field label="* Url" marginTop="large">
        <input name="url" value={url} type="url" {...handlers} />
      </Form.Field>

      <Form.Field label="* Link Text" marginTop="large">
        <input name="link_text" value={link_text} type="text" {...handlers} />
      </Form.Field>

      <Form.Field label="Display on Status" marginTop="large">
        <select
          onChange={e => setEntityState({ status_id: e.target.value })}
          value={status_id}
        >
          <option value="">All</option>
          {filteredStatuses.map(status => (
            <option key={status.id} value={status.id}>
              {status.title}
            </option>
          ))}
        </select>
      </Form.Field>
    </>
  )
}

export default ManageDeepLink
